import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class CardContainerHeaderAPI extends ComponentAPI {
    isHighlighted() {
        return Boolean(this.state.highlighted);
    }
    setHighlighted(highlighted) {
        this.setState({ highlighted });
    }
}
export { CardContainerHeaderAPI, };
//# sourceMappingURL=card-container-header-api.js.map